<template>
  <div :class="wrpCls">
    <LoadingPop v-if="showGlobalLoading" ref="globalLoading" width="100%" />
    <a-space size="middle">
      <!-- 智慧大屏 -->
      <a
        v-if="hasPermission('abm-fix:stat:screen') && hasPermission('abm-fix:stat:home2')"
        class="image_a"
        :class="{ blinking_text: animate }"
        @click="handleScreen"
      >
        智慧大屏
      </a>

      <!-- 租户切换 -->
      <template v-if="tenantListed && tenantListed.length !== 1">
        <a-dropdown>
          <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
            {{ userTentant.tenantName }}（{{
              userTentant.type === 0 ? '平台' : userTentant.type === 1 ? '企业品牌' : '经销商'
            }}）
          </a>
          <a-menu slot="overlay">
            <a-menu-item
              v-for="item in tenantListed"
              :key="item.tenantId"
              :style="item.tenantId === tenantId ? 'background:#1890ff;color:#fff' : ''"
            >
              <a @click="handleChoose(item)">
                {{ item.tenantName }}（{{
                  item.type === 0 ? '平台' : item.type === 1 ? '企业品牌' : item.type === 2 ? '经销商' : '区域'
                }}）
              </a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>

      <screenfull />
      <avatar-dropdown :menu="showMenu" :current-user="currentUser" :class="prefixCls" />
    </a-space>
  </div>
</template>

<script>
import AvatarDropdown from './AvatarDropdown'
import Screenfull from '@/components/Screenfull'
import { mapGetters } from 'vuex'
import { generatorDynamicRouter } from '@/router/generator-routers.js' // 你已有的生成器
import { message } from 'ant-design-vue'

export default {
  name: 'RightContent',
  components: { AvatarDropdown, Screenfull },
  props: {
    prefixCls: { type: String, default: 'ant-pro-global-header-index-action' },
    isMobile: { type: Boolean, default: false },
    topMenu: { type: Boolean, required: true },
    theme: { type: String, required: true },
  },
  data() {
    return {
      showMenu: true,
      currentUser: {},
      tenantListed: [],
      tenantId: '',
      animate: true,
      showGlobalLoading: false,
    }
  },
  computed: {
    wrpCls() {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${this.isMobile || !this.topMenu ? 'light' : this.theme}`]: true,
      }
    },
    ...mapGetters(['userTentant', 'infoUser']),
    hasPermission() {
      return (permission) =>
        this.$store.state.user.userTentant.type === 0 || this.$store.state.user.permissions.includes(permission)
    },
  },
  mounted() {
    setTimeout(() => {
      this.currentUser = { name: 'RuoYi' }
    }, 1500)
  },
  created() {
    this.tenantId = this.userTentant.tenantId
    this.tenantListed = this.infoUser.tenantListed || []
  },
  methods: {
    handleScreen() {
      this.$router.push('/user/home')
    },

    /* ===== 切换用户：利用你已有 generatorDynamicRouter ===== */
    async handleChoose(item) {
      this.toggleGlobalLoading(true)
      let reloadScheduled = false
      try {
        const target = { ...item }
        localStorage.setItem('userTentant', JSON.stringify(target))
        this.$store.commit('USE_RTENANT', target)
        this.$store.commit('SET_PERMISSIONS', target.permissions || [])

        const { menus, routers } = await generatorDynamicRouter()
        console.log(123)

        // 防御：确保是数组
        const routeArray = Array.isArray(routers) ? routers : [routers]

        console.log('menus:', menus)
        console.log('routers:', routers)
        console.log(routeArray, 'routeArray')

        this.$router.addRoutes(routeArray)

        const firstPath = this.getFirstPath(menus)
        await this.$router.replace(firstPath)
        message.success('切换成功，请稍后。。。')
        setTimeout(() => location.reload(), 350)
        reloadScheduled = true
      } catch (e) {
        if (
          e.name === 'NavigationDuplicated' ||
          e.message?.includes('Navigation cancelled') ||
          e.message?.includes('Avoided redundant navigation')
        ) {
          this.toggleGlobalLoading(false)
          return
        }
        console.error('租户切换失败：', e)
        message.error('切换失败，请刷新重试')
        this.$router.replace('/')
        setTimeout(() => location.reload(), 350)
        reloadScheduled = true
      } finally {
        if (!reloadScheduled) {
          this.toggleGlobalLoading(false)
        }
      }
    },

    /* 工具：取第一个叶子节点路径 */
    getFirstPath(list) {
      let node = list[0]
      while (node.children?.length) node = node.children[0]
      return '/' + (node.path || node.name || 'dashboard')
    },
    toggleGlobalLoading(visible) {
      this.showGlobalLoading = visible
      if (visible) {
        this.$nextTick(() => {
          const loadingRef = this.$refs.globalLoading
          if (loadingRef && typeof loadingRef.init === 'function') {
            loadingRef.init(1)
          }
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.image_a {
  font-size: 20px;
}
.blinking_text {
  animation: blink-and-change-color 3s infinite linear;
  transition: color 0.5s linear, opacity 0.5s linear;
}
@keyframes blink-and-change-color {
  0% {
    opacity: 1;
    color: red;
  }
  25% {
    opacity: 1;
    color: orange;
  }
  50% {
    opacity: 0;
    color: yellow;
  }
  75% {
    opacity: 1;
    color: green;
  }
  100% {
    opacity: 1;
    color: blue;
  }
}
</style>
